/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "REST",
            "endpoint": "https://u1uselyix3.execute-api.us-east-2.amazonaws.com/dev",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://nho7fqxyknau5pqbonln4utcv4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:fc4f3a81-44a3-4f9a-9982-ac99258dade9",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_THkRJYjJS",
    "aws_user_pools_web_client_id": "6jh86dh2b179f8tn4c9m3ghr5f",
    "oauth": {
        "domain": "businessprofile51e213fc-51e213fc-dev.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://admin.inprofile.co/",
        "redirectSignOut": "http://localhost:3000/,https://admin.inprofile.co/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "businessprofile-20240704193904-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d3t456vlnn7k0p.cloudfront.net",
    "aws_user_files_s3_bucket": "litebizstorage859e2-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
